import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MessageCircle, Phone, Instagram, X, MessageSquare, Send } from 'lucide-react';
export function FloatingWidget() {
  const [isOpen, setIsOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show widget after scrolling past hero
      setIsVisible(window.scrollY > 500);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-183" data-mp="34dyhxg4gq4rk">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 50
    }} className="fixed bottom-6 right-6 z-50 flex flex-col items-end" data-id="element-184" data-mp="34frsv7m3zb5d">
          <AnimatePresence data-id="element-185" data-mp="foqpkse9pa62">
            {isOpen && <motion.div initial={{
          opacity: 0,
          scale: 0.8,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.8,
          y: 20
        }} className="mb-4 bg-white rounded-2xl shadow-2xl border border-brand-beige p-2 flex flex-col gap-2" data-id="element-186" data-mp="n5eq5vh1vzz3">
                <a href="tel:+380964797313" className="flex items-center gap-3 px-4 py-3 hover:bg-brand-cream rounded-xl transition-colors text-brand-dark font-medium" data-id="element-187" data-mp="dgda65ai9il4">
                  <div className="w-8 h-8 bg-brand-burgundy/10 rounded-full flex items-center justify-center" data-id="element-188" data-mp="3gxn54ku5nkac">
                    <Phone className="w-4 h-4 text-brand-burgundy" data-id="element-189" data-mp="3lveyljag7egn" />
                  </div>
                  Зателефонувати
                </a>
                <a href="viber://chat?number=%2B380964797313" className="flex items-center gap-3 px-4 py-3 hover:bg-brand-cream rounded-xl transition-colors text-brand-dark font-medium" data-id="element-190" data-mp="szlno8kqa3sj">
                  <div className="w-8 h-8 bg-[#7360F2]/10 rounded-full flex items-center justify-center" data-id="element-191" data-mp="xrwr3leog7pu">
                    <MessageCircle className="w-4 h-4 text-[#7360F2]" data-id="element-192" data-mp="a22en4y9sl64" />
                  </div>
                  Viber
                </a>
                <a href="https://t.me/+380964797313" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 px-4 py-3 hover:bg-brand-cream rounded-xl transition-colors text-brand-dark font-medium" data-id="element-193" data-mp="55lq49n5s4si">
                  <div className="w-8 h-8 bg-[#229ED9]/10 rounded-full flex items-center justify-center" data-id="element-194" data-mp="1uks5dqcx2z7f">
                    <Send className="w-4 h-4 text-[#229ED9]" data-id="element-195" data-mp="1plyr3vpt3467" />
                  </div>
                  Telegram
                </a>
                <a href="https://www.instagram.com/na.lilu" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 px-4 py-3 hover:bg-brand-cream rounded-xl transition-colors text-brand-dark font-medium" data-id="element-196" data-mp="222q20ua02ft8">
                  <div className="w-8 h-8 bg-[#E1306C]/10 rounded-full flex items-center justify-center" data-id="element-197" data-mp="2gs5ovz6eu13n">
                    <Instagram className="w-4 h-4 text-[#E1306C]" data-id="element-198" data-mp="2low4kleayuoj" />
                  </div>
                  Instagram
                </a>
              </motion.div>}
          </AnimatePresence>

          <button onClick={() => setIsOpen(!isOpen)} className="w-14 h-14 bg-brand-burgundy text-white rounded-full shadow-lg flex items-center justify-center hover:bg-brand-burgundy/90 transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-burgundy" aria-label="Contact options" data-id="element-199" data-mp="2bz33iebsdxyj">
            {isOpen ? <X className="w-6 h-6" data-id="element-200" data-mp="1bs7pahf164rd" /> : <MessageSquare className="w-6 h-6" data-id="element-201" data-mp="16u68k352uhj2" />}
          </button>
        </motion.div>}
    </AnimatePresence>;
}